import React from "react";
import { Row } from "react-bootstrap";
import { IProperty } from "../../../../shared/interfaces/IProperties";

interface Props {
    propertyInfo?: IProperty;
}

export const PalmeiraPrincipaisDados: React.FC<Props> = ({ propertyInfo }) => {
    return (
        <div style={{ pageBreakBefore: "always" }}>
            {propertyInfo?.zoneamento?.zona &&
                propertyInfo?.zoneamento?.zona.includes("SIM") && (
                    <>
                        <p className="font-semibold text-green-600">
                            ÁREA DE PRESERVAÇÃO PERMANENTE ► ÁREA VERDE ► APP
                        </p>

                        {/* <table className="table">
                            <tbody>
                                <tr
                                    className="border-0"
                                    style={{ background: "#D0CECE" }}
                                >
                                    <td className="border-r-2 border-white">
                                        Área de Preservação Permanente (APP)
                                        corresponde a todas às margens dos rios
                                        urbanos e municipais, isto é, às faixas
                                        de preservação ao longo de rios,
                                        córregos e nascentes, definida por Lei
                                        Federal, tendo por objetivo proteger os
                                        cursos d`água e suas margens; manter o
                                        equilíbrio de todo o ecossistema natural
                                        da região e configurar importante
                                        corredor de biodiversidade e refúgio
                                        para a avifauna local.
                                    </td>
                                </tr>
                            </tbody>
                        </table> */}
                    </>
                )}

            <p className="font-semibold">
                DADOS PRINCIPAIS SOBRE O LOTE ► SMDU | SMGPF
            </p>

            <Row>
                <table className="table">
                    <tbody>
                        <tr
                            className="border-0"
                            style={{ background: "#D0CECE" }}
                        >
                            {/* <td className="border-r-2 border-white">
                                CAD IMOBILIÁRIO
                            </td> */}
                            <td className="border-r-2 border-white">
                                ÁREA DO LOTE
                            </td>
                            <td className="border-r-2 border-white">
                                ÁREA EDIFICADA
                            </td>
                            <td className="border-r-2 border-white">
                                PROFUNDIDADE
                            </td>
                            {/* <td className="border-r-2 border-white">
                                TX OCUPAÇ
                            </td>
                            <td className="border-r-2 border-white">
                                COEFIC. APROV
                            </td>
                            <td style={{ color: "#ff0000" }}>PERMEABIL</td> */}
                        </tr>
                        <tr style={{ background: "#D0CECE" }}>
                            {/* <td className="border-r-2 border-white">(UN)</td> */}
                            <td className="border-r-2 border-white">(m²)</td>
                            <td className="border-r-2 border-white">(m²)</td>
                            <td className="border-r-2 border-white">(m)</td>
                            {/* <td className="border-r-2 border-white">UN</td>
                            <td className="border-r-2 border-white">UN</td>
                            <td style={{ color: "#ff0000" }}>%</td> */}
                        </tr>
                        <tr style={{ background: "#E7E6E6" }}>
                            {/* <td className="border-r-2 border-white">
                                {propertyInfo?.cadastro}
                            </td> */}
                            <td className="border-r-2 border-white">
                                {propertyInfo?.areaterreno}
                            </td>
                            <td className="border-r-2 border-white">
                                {propertyInfo?.areaconstruida}
                            </td>
                            <td className="border-r-2 border-white">
                                {propertyInfo?.profundidade}
                            </td>
                            {/* <td className="border-r-2 border-white">-</td>
                            <td className="border-r-2 border-white">-</td>
                            <td style={{ color: "#ff0000" }}>-</td> */}
                        </tr>
                    </tbody>
                </table>
            </Row>
        </div>
    );
};
